import React from "react";
import { View, ScrollView, Text, StyleSheet } from "react-native";
import {
  buttonsAdminMenu,
  ButtonList,
} from "../components/Common/ComponentButtons.js";
import { styles } from "../style/styles.js";
import { useSelector } from "react-redux";
import { versionJTS } from "../constants/Constants";
import AppScreenBackground from "../components/Common/ComponentAppBackground.jsx";

export default function AdminCenterData({ navigation }) {
  const equipo = useSelector((state) => state.user.team);
  const nivelAcceso = useSelector((state) => state.user.nivel_acceso);

  return (
    <AppScreenBackground style={styles.backgrounOptionDos}>
      <ScrollView style={styles.backgrounOptionDos}>
        <View>
          <Text style={styles.contadorVersion}>{versionJTS}</Text>
          <View style={[styles.row, { paddingTop: 50 }]}>
            <ButtonList
              buttons={buttonsAdminMenu({ navigation, equipo, nivelAcceso })}
              isAdminMenu={true}
            />
          </View>
        </View>
      </ScrollView>
    </AppScreenBackground>
  );
}
